module.exports = __webpack_public_path__ + "img/a-ziyuan2.22ea0df7.png";